"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.platformCliVersion = void 0;
exports.platformCliVersion = '3.6.1';
